<template>
  <ValidationObserver
    v-slot="{
      invalid
    }"
    tag="div"
  >
    <div :class="$style.formContainer">
      <InputLabel :text="questionLabels.usersCount" />
      <InputNumberInline
        v-model="usersCount"
        :class="[$style.inputWrapper, $style.selectSpacer]"
        name="users-count"
        textAfter=" users"
        textBefore=""
      />
      <RadioGroup
        v-model="sso"
        :label="questionLabels.sso"
        name="sso"
        :options="radioOptions.options"
      />
      <RadioGroup
        v-model="mfa"
        :label="questionLabels.mfa"
        name="mfa"
        :options="radioOptions.options"
      />
      <RadioGroup
        v-model="legacy"
        :label="questionLabels.legacy"
        name="legacy"
        :options="radioOptions.options"
      />
      <RadioGroup
        v-model="networkEquipment"
        :label="questionLabels.networkEquipment"
        name="network-equipment"
        :options="radioOptions.options"
      />
      <Select
        v-model="reportCompliance"
        :class="$style.selectSpacer"
        :label="questionLabels.reportCompliance"
        name="reportCompliance"
        :options="reportFrequencyOptions"
        :required="true"
      />
      <InputLabel :text="questionLabels.osTypes" />
      <ul
        class="jc-clearlist"
        :class="$style.devicesQuestion"
      >
        <li :class="[$style.option, $style.optionSpacer]">
          <Checkbox
            v-model="mac"
            label="Apple"
          />
        </li>
        <li :class="[$style.option, $style.optionSpacer]">
          <Checkbox
            v-model="windows"
            label="Windows"
          />
        </li>
        <li :class="[$style.option, $style.optionSpacer]">
          <Checkbox
            v-model="linux"
            label="Linux"
          />
        </li>
      </ul>
      <RadioGroup
        v-model="conditionalAccess"
        :label="questionLabels.conditionalAccess"
        name="conditional-access"
        :options="radioOptions.options"
      />
    </div>
    <div>
      <Button
        :class="$style.calculateEstimate"
        data-test-id="PricingCalculatorForm__button"
        :isDisabled="invalid || !enableMainAction"
        text="Calculate Estimate"
        type="primary"
        @click="handleSubmit"
      />
    </div>
  </ValidationObserver>
</template>

<script>
import {
  Button,
  Checkbox,
  InputLabel,
  InputNumberInline,
  RadioGroup,
  Select,
} from '@jumpcloud/ui-components';
import { ValidationObserver } from 'vee-validate3';

export default {
  name: 'PricingCalculatorForm',

  components: {
    Button,
    Checkbox,
    InputLabel,
    InputNumberInline,
    RadioGroup,
    Select,
    ValidationObserver,
  },

  props: {
    savedAnswers: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      sso: '',
      mfa: '',
      mac: false,
      linux: false,
      windows: false,
      legacy: '',
      networkEquipment: '',
      reportCompliance: '',
      usersCount: 50,
      conditionalAccess: '',
      radioOptions: {
        options: [
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' },
        ],
      },
      reportFrequencyOptions: [
        { name: 'Never', value: 'never' },
        { name: 'Daily', value: 'daily' },
        { name: 'Weekly', value: 'weekly' },
        { name: 'Monthly', value: 'monthly' },
        { name: 'During Audit', value: 'audit' },
      ],
      questionLabels: {
        usersCount: '1. How many users do you have?',
        sso: '2. Do you need authenticate into web applications with SSO?',
        mfa: '3. Do you use multi-factor authentication?',
        legacy: '4. Do you need to auth legacy or on-perm apps and servers?',
        networkEquipment: '5. Do you authenticate network equipment, like wireless access points, routers, and switches, from your directory?',
        reportCompliance: '6. How frequently do you need to report on administrator and end user activity for compliance needs?',
        osTypes: '7. What type(s) of devices do you manage?',
        conditionalAccess: '8. Do you use conditional access policies?',
      },
    };
  },

  computed: {
    answers() {
      return {
        sso: this.sso,
        usersCount: parseInt(this.usersCount, 10),
        mfa: this.mfa,
        mac: this.mac,
        windows: this.windows,
        linux: this.linux,
        reportCompliance: this.reportCompliance,
        networkEquipment: this.networkEquipment,
        legacy: this.legacy,
        conditionalAccess: this.conditionalAccess,
      };
    },
    enableMainAction() {
      return this.conditionalAccess
        && this.sso
        && this.mfa
        && this.legacy
        && this.networkEquipment
        && this.usersCount
        && this.reportCompliance;
    },
  },

  mounted() {
    // Save answers individually bc that's how it's stored in data
    Object.keys(this.savedAnswers).forEach((field) => {
      this[field] = this.savedAnswers[field];
    });
  },

  methods: {
    handleSubmit() {
      this.$emit('calculateEstimate', this.answers);
    },
  },
};
</script>

<style module scoped>
.calculateEstimate {
  margin-bottom: 4rem;
  margin-top: 2rem;
}

.formContainer {
  border: 0.2rem solid var(--jcGrey200);
  border-radius: 0.3rem;
  height: 500px;
  overflow: auto;
  padding: 2rem;
  width: 100%;
}

.inputWrapper {
  --inline-input-width: 8ch;
}

.optionSpacer {
  margin-bottom: var(--jc-spacer);
}

.selectSpacer {
  margin-bottom: 0.75rem;
}

.devicesQuestion.devicesQuestion {
  margin-bottom: var(--jc-spacer-large);
}
</style>
